export default __webpack_public_path__ + "static/media/pgso.986395a9.png";